<template>
  <li
    class="event"
    :class="[
      `event--${width}`,
      {
        'event--stream': item.stream,
        'event--location': item.location
      }
    ]">
    <div
      v-if="item.image"
      class="event__image"
      :class="{
        'event__image--landscape': item.image.width >= item.image.height,
        'event__image--portrait': item.image.height > item.image.width
      }">
      <router-link :to="`/events/${item.slug}`">
        <img :src="item.image.sizes.medium_large" />
      </router-link>
      <p
        v-if="item.stream"
        class="event__image-note">
        Live stream
      </p>
    </div>
    <router-link :to="`/events/${item.slug}`">
      <p
        class="event__title"
        v-html="item.name"></p>
    </router-link>
    <h5 v-if="!item.custom_date && ((item.start_date && item.end_date) || (item.start_date && item.start_time && item.end_time))">
        <span v-html="$formatTimeRange(item.start_date, item.start_time, item.end_time)"></span>,
        <span v-html="$formatDateRange(item.start_date, item.end_date)"></span>
    </h5>
    <h5 v-else>
        <span v-html="item.custom_date"></span>
    </h5>
    <h5
      v-if="item.location"
      v-html="item.location.map.address"></h5>
    <h5
      v-if="item.type === 'online'">
      ONLINE
    </h5>
  </li>
</template>

<script>
export default {
  name: 'EventItem',
  props: {
    item: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 33
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  width: calc(50% - #{$padding / 2});
  margin: 0 $padding $padding 0;

  &--33 {
    width: calc(33% - #{$padding * 2 / 3});
    &:nth-child(3n + 3) {
      margin-right: 0px;
    }

    .event__image {
      height: calc((33vw - #{$page-padding * 2} - #{$padding * 2 / 3}) * 0.75);
      max-height: calc((#{$content-width / 3} - #{$page-padding * 2} - #{$padding * 2 / 3}) * 0.75);
    }
  }
  &:hover {
    .event__image {
      img {
        opacity: 0.75;
      }
    }
    .event__title {
      text-decoration: underline;
    }
  }
  &__image {
    background: $grey;
    position: relative;
    margin: 0 0 #{$padding / 2.5} 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: opacity 200ms ease-in-out;
    }

    &-note {
      font-size: $note;
      padding: 6px 12px;
      border: 2px solid $green;
      background: $green;
      position: absolute;
      border-radius: $radius;
      color: #fff;
      top: #{$padding / 2};
      right: #{$padding / 2};
    }
  }

  @media screen and (max-width: $mobile) {
    width: 100%;
    margin: 0 0 $padding 0;

    &__image {
      width: 100%;

      height: calc(96vw * 0.75) !important;
      max-height: unset !important;
    }
  }
}
</style>
